import { Component } from '@theme/component';
import { QuoteList, QuoteUpdateEvent } from '@theme/quote-list';

/**
 * Header badge showing the number of items in the quote list.
 * Count is client-rendered (the server can't read localStorage), so it appears just after load.
 *
 * @typedef {object} Refs
 * @property {HTMLElement} quoteBubble
 * @property {HTMLElement} quoteBubbleCount
 *
 * @extends {Component<Refs>}
 */
class QuoteIcon extends Component {
  requiredRefs = ['quoteBubble', 'quoteBubbleCount'];

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(QuoteUpdateEvent.eventName, this.#render);
    window.addEventListener('pageshow', this.#render);
    this.#render();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(QuoteUpdateEvent.eventName, this.#render);
    window.removeEventListener('pageshow', this.#render);
  }

  #render = () => {
    const count = QuoteList.count();
    this.refs.quoteBubbleCount.textContent = count < 100 ? String(count) : '99+';
    this.refs.quoteBubble.classList.toggle('visually-hidden', count === 0);
    this.refs.quoteBubbleCount.classList.toggle('hidden', count === 0);
    this.classList.toggle('header-actions__cart-icon--has-cart', count > 0);
  };
}

if (!customElements.get('quote-icon')) {
  customElements.define('quote-icon', QuoteIcon);
}
